import { number, object, string } from "yup";
import { GENDER_FEMALE, GENDER_MALE } from "../../utils/constants";

export const PATIENT_SCHEMA = object({
  patient_id: string().required(),
  birth_date: number().required(),
  gender: string().oneOf([GENDER_MALE, GENDER_FEMALE]).required(),
  birth_zip_code: number(),
  residential_zip_code: number(),
  comments: string(),
});

export const renderFormError = (error) => {
  if (
    (error.path === "residential_zip_code" || error.path === "birth_zip_code") &&
    error.type === "typeError" &&
    isNaN(error.params.value)
  ) {
    return "Postal code must be a number";
  }

  if (error.path === "birth_date") {
    if (!new Date(error.params.value).getTime()) {
      return "You must provide a valid birth date";
    }
  }

  if (error.type === "typeError") {
    return `You must provide a valid ${error.path}`;
  }

  if (error.type === "required") {
    return `${error.path} is a required field`;
  }
};
